import React from 'react';
import styled from 'styled-components';
import PersonalityTitle from 'Components/arctypes/components/PersonalityTitle';
import PersonaQualities from 'Components/arctypes/components/PersonaQualities';
import { Row, Col } from 'antd';
import {
  wMedium, boxShadow, primaryFont, maxWidth, retina,
} from 'Utils/utilsStyle';
import arcType from '../arcType.json';

const Wrapper = styled.div`
  &.personality-detail-card{
    background-color:#fff;
    box-shadow:${boxShadow};
    border-radius:16px;
    padding:55px 26px 40px 26px;
    margin-bottom:50px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-bottom: 20px;
      padding: 30px 26px 20px 26px;
    }
    .personality-title {
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 28px;
      }
    }
    .disc-image{
      width: 360px;
      margin: 0 auto;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 300px;
      }
    }
    .persona-qualities {
      span {
        text-transform: capitalize;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          padding: 3px 25px;
          font-size: 13px;
        }
      }
    }
    .sub-heading{
      margin-top:50px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-top: 20px;
        font-size: 22px;
        margin-bottom: 8px;
      }
    }
    p{
      color:#67696A;
      font-size:18px;
      font-weight:${wMedium};
      font-family:${primaryFont};
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 15px;
      }
    }
    .persona-qualities{
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-top: 10px;
      }
      span{
        &:nth-of-type(1){
          margin-left:0;
        }
        &:nth-last-of-type(1){
          margin-right:0;
        }
      }
    }
  }
`;

const ManagerDetailCard = function ManagerDetailCard() {
  return (
    <Wrapper className="personality-detail-card">
      <Row gutter={26}>
        <Col span={12} className="text-center">
          <PersonalityTitle
            personalityColor={arcType[8].color}
            personalityType={arcType[8].title}
          />
          <img src={arcType[8].disc_image} alt="Disc" className="disc-image" />
        </Col>
        <Col span={12}>
          <div className="persona-qualities">
            {arcType[8].quality?.map((item, key) => (
              <PersonaQualities backgroundColor={arcType[8].color} name={item} index={key} />
            ))}
          </div>
          {arcType[8].description?.map((item, key) => (
            <>
              <h3 className="sub-heading" tabIndex={key}>
                {item.heading}
              </h3>
              <p>
                {item.summary}
              </p>
            </>
          ))}
        </Col>
      </Row>
    </Wrapper>
  );
};

export default ManagerDetailCard;
